module.exports = "//static.hsappstatic.net/conversations-embed/static-1.26522/sass/messagesWidgetShell.sass"